import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'polyfill';
import React, { lazy } from 'react';
import 'index.css';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import '@payer-admin-ui/components/src/Localization/i18n';
import store from './redux/store';

const App = lazy(() => import('App'));
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
